import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { Btn, Empty } from "../UI";
import { FSelect } from "../../pages/engagement/FormControls";
import { LogCommunicationForm } from "./LogCommunicationForm";
import { CommRow, FILTERS, PARTIES, filterParams } from "./commShared";
import { Plus } from "lucide-react";

/** Client chart > Communications: every call, text, email, and refill request for this client. */
export function CommunicationLog({ client, editable }) {
  const [rows, setRows] = useState(null);
  const [f, setF] = useState("");
  const [party, setParty] = useState("");
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get(`/clients/${client.id}/communications`, { params: { ...filterParams(f), party_type: party || undefined } })
    .then((r) => setRows(r.data)).catch((e) => toast.error(apiError(e))), [client.id, f, party]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="communication-log">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-2">
          <div className="flex rounded-full bg-[#F5F2EB] p-1" role="tablist">{FILTERS.map(([k, l]) => (
            <button key={l} type="button" role="tab" aria-selected={f === k} data-testid={`comm-filter-${l.toLowerCase()}`} onClick={() => setF(k)}
              className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${f === k ? "bg-[#4E342E] text-white" : "text-[#6D4C41]"}`}>{l}</button>))}</div>
          <div className="w-52"><FSelect data-testid="comm-filter-party" value={party} placeholder="Everyone" onChange={(e) => setParty(e.target.value)}>
            {PARTIES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</FSelect></div>
        </div>
        {editable && <Btn data-testid="comm-log-btn" onClick={() => setOpen(true)}><Plus size={14} /> Log call, text, or email</Btn>}
      </div>
      <p className="mb-3 text-xs text-[#7B6157]">Includes prescription emails and pharmacy calls, handout emails, and refill requests. Log refill requests from the Medications tab.</p>
      <div className="space-y-2">{(rows || []).map((x) => <CommRow key={x.id} x={x} />)}</div>
      {rows && !rows.length && <Empty text="Nothing logged yet." />}
      <LogCommunicationForm client={client} open={open} onClose={() => setOpen(false)} onSaved={() => { setOpen(false); load(); }} />
    </div>
  );
}
